import React from "react";

export function CustomIcon(props) {
  switch (props.icon) {
    case "dashboard":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15.938"
          height="15"
          viewBox="0 0 15.938 15"
        >
          <title id="title">Dashboard</title>
          <path
            d="M15.463-4.687H8.511l4.63,4.63a.47.47,0,0,0,.65.02,7.016,7.016,0,0,0,2.142-4.127A.47.47,0,0,0,15.463-4.687ZM15-6.586a7.048,7.048,0,0,0-6.538-6.538.471.471,0,0,0-.492.475v6.555h6.556A.471.471,0,0,0,15-6.586Zm-8.436,1.9v-6.952a.469.469,0,0,0-.523-.47A7.026,7.026,0,0,0,0-4.911,7.118,7.118,0,0,0,7.12,1.874,6.977,6.977,0,0,0,11.083.584a.466.466,0,0,0,.046-.705Z"
            transform="translate(0 13.125)"
          />
        </svg>
      );
      break;

    case "blackscholes":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15.938"
          height="15"
          viewBox="0 0 11.25 15"
        >
          <title id="title">Black scholes</title>
          <path
            d="M8.437-5.625H2.812V-3.75H8.437Zm2.607-4.424L8.177-12.92a.7.7,0,0,0-.5-.205H7.5v3.75h3.75v-.179A.7.7,0,0,0,11.045-10.049Zm-4.482.908v-3.984H.7a.7.7,0,0,0-.7.7V1.172a.7.7,0,0,0,.7.7h9.844a.7.7,0,0,0,.7-.7V-8.437H7.266A.705.705,0,0,1,6.562-9.141ZM1.875-11.016a.234.234,0,0,1,.234-.234H4.453a.234.234,0,0,1,.234.234v.469a.234.234,0,0,1-.234.234H2.109a.234.234,0,0,1-.234-.234Zm0,1.875a.234.234,0,0,1,.234-.234H4.453a.234.234,0,0,1,.234.234v.469a.234.234,0,0,1-.234.234H2.109a.234.234,0,0,1-.234-.234Zm7.5,8.906A.234.234,0,0,1,9.141,0H6.8a.234.234,0,0,1-.234-.234V-.7A.234.234,0,0,1,6.8-.937H9.141A.234.234,0,0,1,9.375-.7Zm0-5.859v2.812a.469.469,0,0,1-.469.469H2.344a.469.469,0,0,1-.469-.469V-6.094a.469.469,0,0,1,.469-.469H8.906A.469.469,0,0,1,9.375-6.094Z"
            transform="translate(0 13.125)"
          />
        </svg>
      );
      break;

    case "settings":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15.938"
          height="15"
          viewBox="0 0 13.911 14.531"
        >
          <title id="title">Settings</title>
          <path
            d="M14.279-3.876,13.031-4.6a5.643,5.643,0,0,0,0-2.057l1.248-.721a.354.354,0,0,0,.161-.41,7.3,7.3,0,0,0-1.6-2.771.352.352,0,0,0-.434-.067L11.156-9.9a5.529,5.529,0,0,0-1.781-1.028v-1.438a.351.351,0,0,0-.275-.343,7.365,7.365,0,0,0-3.2,0,.351.351,0,0,0-.275.343v1.441A5.7,5.7,0,0,0,3.844-9.9L2.6-10.62a.348.348,0,0,0-.434.067,7.253,7.253,0,0,0-1.6,2.771.35.35,0,0,0,.161.41l1.248.721a5.643,5.643,0,0,0,0,2.057L.724-3.873a.354.354,0,0,0-.161.41,7.3,7.3,0,0,0,1.6,2.771A.353.353,0,0,0,2.6-.624l1.248-.721A5.529,5.529,0,0,0,5.628-.316V1.125a.351.351,0,0,0,.275.343,7.365,7.365,0,0,0,3.2,0,.351.351,0,0,0,.275-.343V-.316a5.7,5.7,0,0,0,1.781-1.028l1.248.721a.348.348,0,0,0,.434-.067,7.253,7.253,0,0,0,1.6-2.771A.362.362,0,0,0,14.279-3.876ZM7.5-3.281A2.347,2.347,0,0,1,5.156-5.625,2.347,2.347,0,0,1,7.5-7.969,2.347,2.347,0,0,1,9.844-5.625,2.347,2.347,0,0,1,7.5-3.281Z"
            transform="translate(-0.546 12.888)"
          />
        </svg>
      );
    case "logout":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15.938"
          height="15"
          viewBox="0 0 15.001 11.25"
        >
          <title id="title">Logout</title>
          <path
            d="M5.273,0a.353.353,0,0,0,.352-.352V-1.523a.353.353,0,0,0-.352-.352H2.812a.936.936,0,0,1-.937-.937V-8.437a.936.936,0,0,1,.937-.937H5.273a.353.353,0,0,0,.352-.352V-10.9a.353.353,0,0,0-.352-.352H2.812A2.813,2.813,0,0,0,0-8.437v5.625A2.813,2.813,0,0,0,2.812,0ZM8.728-8.88,11-6.8H5.391a.7.7,0,0,0-.7.7v.937a.7.7,0,0,0,.7.7H11L8.728-2.37A.705.705,0,0,0,8.7-1.354l.642.642a.706.706,0,0,0,.993,0l4.453-4.418a.7.7,0,0,0,0-1l-4.45-4.412a.7.7,0,0,0-.993,0l-.642.642A.7.7,0,0,0,8.728-8.88Z"
            transform="translate(0 11.25)"
          />
        </svg>
      );

    case "taabladmin":
      return (
        <svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512">
          <g>
            <g>
              <path
                d="M506.82,406.855l-101.867-61.12L383.982,10.012c-0.256-4.181-2.944-7.829-6.869-9.323
			c-3.925-1.472-8.363-0.533-11.307,2.432l-36.715,36.715c-12.309-6.869-38.336-18.496-73.088-18.496s-60.779,11.627-73.088,18.496
			L146.222,3.122c-2.987-2.987-7.403-3.904-11.307-2.432c-3.925,1.493-6.613,5.12-6.869,9.323l-20.992,335.723L5.188,406.855
			c-3.221,1.941-5.184,5.397-5.184,9.152v85.333c0,5.888,4.779,10.667,10.667,10.667h490.667c5.888,0,10.667-4.779,10.667-10.667
			v-85.333C512.004,412.253,510.041,408.797,506.82,406.855z M171.801,155.228c2.645-5.269,9.045-7.381,14.315-4.757l21.12,10.56
			c0.128,0.064,0.277,0.128,0.384,0.192l21.141,10.581c4.437,2.219,6.741,7.168,5.611,11.989s-5.419,8.213-10.368,8.213H202.67
			c-5.888,0-10.667-4.779-10.667-10.667v-4.075l-15.445-7.723C171.289,166.919,169.156,160.498,171.801,155.228z M284.782,341.34
			h-57.536l-55.083-36.715l16.853-67.349l64.064,18.304c1.92,0.533,3.947,0.533,5.845,0l64.064-18.304l16.853,67.349L284.782,341.34
			z M335.449,169.543l-16.107,8.043c0.427,1.173,0.661,2.432,0.661,3.755c0,5.888-4.779,10.667-10.667,10.667h-21.333
			c-4.949,0-9.259-3.413-10.389-8.213c-1.131-4.8,1.195-9.771,5.611-11.989l42.667-21.333c5.291-2.624,11.669-0.491,14.315,4.779
			C342.852,160.498,340.718,166.919,335.449,169.543z"
              />
            </g>
          </g>
        </svg>
      );

    case "companies":
      return (
        <svg
          id="Layer_1"
          enableBackground="new 0 0 496 496"
          height="512"
          viewBox="0 0 496 496"
          width="512"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m433.551 464h-31.551v-392c0-8.837-7.163-16-16-16h-120v-40c0-8.837-7.163-16-16-16h-111c-8.837 0-16 7.163-16 16v40h-13c-8.837 0-16 7.163-16 16v392h-31.551c-8.618 0-16.03 6.626-16.431 15.234-.428 9.189 6.888 16.766 15.982 16.766h114c4.418 0 8-3.582 8-8v-92h-6.548c-8.615 0-16.028-6.621-16.434-15.226-.433-9.188 6.889-16.774 15.982-16.774 4.831 0 145.545 0 141.548 0 8.615 0 16.028 6.621 16.434 15.226.433 9.188-6.888 16.774-15.982 16.774h-7v92c0 4.418 3.582 8 8 8h114c9.094 0 16.41-7.577 15.982-16.766-.401-8.608-7.813-15.234-16.431-15.234zm-224.551-133h-18c-8.836 0-16-7.164-16-16s7.164-16 16-16h18c8.836 0 16 7.164 16 16s-7.164 16-16 16zm0-60h-18c-8.836 0-16-7.164-16-16s7.164-16 16-16h18c8.836 0 16 7.164 16 16s-7.164 16-16 16zm0-60h-18c-8.836 0-16-7.164-16-16s7.164-16 16-16h18c8.836 0 16 7.164 16 16s-7.164 16-16 16zm0-60h-18c-8.836 0-16-7.164-16-16s7.164-16 16-16h18c8.836 0 16 7.164 16 16s-7.164 16-16 16zm95 180h-18c-8.837 0-16-7.164-16-16s7.163-16 16-16h18c8.837 0 16 7.164 16 16s-7.163 16-16 16zm0-60h-18c-8.837 0-16-7.164-16-16s7.163-16 16-16h18c8.837 0 16 7.164 16 16s-7.163 16-16 16zm0-60h-18c-8.837 0-16-7.164-16-16s7.163-16 16-16h18c8.837 0 16 7.164 16 16s-7.163 16-16 16zm0-60h-18c-8.837 0-16-7.164-16-16s7.163-16 16-16h18c8.837 0 16 7.164 16 16s-7.163 16-16 16zm-88 337v-84c0-4.418 3.582-8 8-8h48c4.418 0 8 3.582 8 8v84c0 4.418-3.582 8-8 8h-48c-4.418 0-8-3.582-8-8z" />
        </svg>
      );

    case "employees":
      return (
        <svg
          height="512"
          viewBox="0 0 192 192"
          width="512"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="_23-teamwork" data-name="23-teamwork">
            <g id="Glyph">
              <circle cx="152" cy="72" r="24" />
              <circle cx="40" cy="72" r="24" />
              <circle cx="96" cy="56" r="32" />
              <path d="m176 104h-28.3a31.8 31.8 0 0 1 4.3 16v56h32a8 8 0 0 0 8-8v-48a16 16 0 0 0 -16-16z" />
              <path d="m44.305 104h-28.305a16 16 0 0 0 -16 16v48a8 8 0 0 0 8 8h32v-56a31.8 31.8 0 0 1 4.305-16z" />
              <path d="m120 88h-8l-16 48-16-48h-8a24 24 0 0 0 -24 24v72a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8v-72a24 24 0 0 0 -24-24z" />
            </g>
          </g>
        </svg>
      );

    case "expenses":
      return (
        <svg
          id="Layer_1_1_"
          enableBackground="new 0 0 64 64"
          height="512"
          viewBox="0 0 64 64"
          width="512"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m42 10h6l-6-6z" />
          <path d="m41 62h21v-24h-21zm12-3h-3v-2h3zm0-4h-3v-2h3zm0-4h-3v-2h3zm5 8h-3v-2h3zm0-4h-3v-2h3zm0-4h-3v-2h3zm-13-9h13v4h-13zm0 7h3v2h-3zm0 4h3v2h-3zm0 4h3v2h-3z" />
          <path d="m39 36h11v-24h-10v-10h-38v50h37zm3-3h-2v-2h2zm4 0h-2v-2h2zm-10-14h10v2h-10zm0 4h10v2h-10zm0 4h10v2h-10zm-6.63605-15.36395c3.51471 3.51471 3.51471 9.2132 0 12.72791l-6.36395-6.36396zm-18.36395 27.36395h2c1.6543 0 3 1.3457 3 3v1c0 1.6543-1.3457 3-3 3v2h-2v-2c-1.6543 0-3-1.3457-3-3h2c0 .55127.44873 1 1 1h2c.55127 0 1-.44873 1-1v-1c0-.55127-.44873-1-1-1h-2c-1.6543 0-3-1.3457-3-3v-1c0-1.6543 1.3457-3 3-3v-2h2v2c1.6543 0 3 1.3457 3 3h-2c0-.55127-.44873-1-1-1h-2c-.55127 0-1 .44873-1 1v1c0 .55127.44873 1 1 1zm-1.36395-14.63605c-3.51471-3.51471-3.51471-9.2132 0-12.72791 3.51471-3.51477 9.2132-3.51477 12.72791 0l-6.36396 6.36396 6.36395 6.36395c-3.51471 3.51471-9.21319 3.51471-12.7279 0zm27.36395 23.63605h-18v-2h3v-5h4v-6h4v3h4v8h3zm1-15h-2v-2h2z" />
        </svg>
      );

    case "companysidebar":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13.125"
          height="15"
          viewBox="0 0 13.125 15"
        >
          <defs></defs>
          <path
            d="M13.125-2.578v-9.844a.7.7,0,0,0-.7-.7H2.812A2.813,2.813,0,0,0,0-10.312V-.937A2.813,2.813,0,0,0,2.812,1.875h9.609a.7.7,0,0,0,.7-.7V.7a.709.709,0,0,0-.261-.548,6.535,6.535,0,0,1,0-2.188A.7.7,0,0,0,13.125-2.578ZM3.75-9.2a.176.176,0,0,1,.176-.176h6.211a.176.176,0,0,1,.176.176v.586a.176.176,0,0,1-.176.176H3.926a.176.176,0,0,1-.176-.176Zm0,1.875A.176.176,0,0,1,3.926-7.5h6.211a.176.176,0,0,1,.176.176v.586a.176.176,0,0,1-.176.176H3.926a.176.176,0,0,1-.176-.176ZM11.174,0H2.812a.936.936,0,0,1-.937-.937.94.94,0,0,1,.937-.937h8.361A10.545,10.545,0,0,0,11.174,0Z"
            transform="translate(0 13.125)"
          />
        </svg>
      );
    case "rerun":
      return (
        <svg
          height="511pt"
          viewBox="0 0 511 511.99973"
          width="511pt"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m75.5 451c8.289062 0 14.996094-6.707031 14.996094-15 0-8.289062-6.707032-15-14.996094-15-24.816406 0-45-20.183594-45-44.996094 0-8.292968-6.710938-15-15-15-8.292969 0-15 6.707032-15 15 0 41.351563 33.644531 74.996094 75 74.996094zm0 0" />
          <path d="m15.5 331.003906c8.289062 0 15-6.710937 15-15v-60c0-8.289062-6.710938-15-15-15-8.292969 0-15 6.710938-15 15v60c0 8.289063 6.707031 15 15 15zm0 0" />
          <path d="m15.5 211.007812c8.289062 0 15-6.710937 15-15v-61c0-24.8125 20.183594-45 45-45h70.457031l-48.777343 32.519532c-6.902344 4.601562-8.761719 13.902344-4.160157 20.800781 4.519531 6.792969 13.785157 8.808594 20.800781 4.160156l89.996094-60c8.964844-5.957031 8.550782-19.273437 0-24.957031l-89.996094-60c-6.945312-4.613281-16.21875-2.738281-20.800781 4.160156-4.601562 6.898438-2.742187 16.199219 4.160157 20.800782l48.777343 32.519531h-70.457031c-41.355469 0-75 33.644531-75 74.996093v61c0 8.289063 6.707031 15 15 15zm0 0" />
          <path d="m195.496094 421h-60c-8.289063 0-15 6.710938-15 15 0 8.292969 6.710937 15 15 15h60c8.289062 0 15-6.707031 15-15 0-8.289062-6.710938-15-15-15zm0 0" />
          <path d="m467.488281.0117188h-181.996093c-24.8125 0-44.996094 20.1835932-44.996094 45.0000002v59.996093c0 24.8125 20.183594 45 44.996094 45h76v31h-76c-24.8125 0-44.996094 20.183594-44.996094 45v59.996094c0 24.8125 20.183594 45 44.996094 45h76v30h-76c-24.8125 0-44.996094 20.183594-44.996094 45v60.996094c0 24.8125 20.183594 45 44.996094 45h181.996093c24.816407 0 45-20.1875 45-45v-60.996094c0-24.816406-20.183593-45-45-45h-75.996093v-30h75.996093c24.816407 0 45-20.1875 45-45v-59.996094c0-24.816406-20.183593-45-45-45h-75.996093v-31h75.996093c24.816407 0 45-20.1875 45-45v-59.996093c0-24.816407-20.183593-45.0000002-45-45.0000002zm-29.996093 420.9882812c8.289062 0 14.996093 6.710938 14.996093 15 0 8.292969-6.707031 15-14.996093 15h-122c-8.289063 0-15-6.707031-15-15 0-8.289062 6.710937-15 15-15zm0-179.996094c8.289062 0 14.996093 6.710938 14.996093 15 0 8.292969-6.707031 15-14.996093 15h-122c-8.289063 0-15-6.707031-15-15 0-8.289062 6.710937-15 15-15zm0-150.996094h-122c-8.289063 0-15-6.707031-15-15 0-8.289062 6.710937-15 15-15h122c8.289062 0 14.996093 6.710938 14.996093 15 0 8.292969-6.707031 15-14.996093 15zm0 0" />
        </svg>
      );

    case "import":
      return (
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 330 330">
          <g id="XMLID_225_">
            <path
              id="XMLID_226_"
              d="M181.213,233.999l11.895,11.895c5.857,5.858,5.857,15.355-0.001,21.214
         c-2.929,2.928-6.769,4.393-10.606,4.393c-3.84,0-7.678-1.465-10.607-4.394l-37.5-37.501c-0.024-0.025-0.046-0.053-0.07-0.078
         c-0.318-0.322-0.624-0.657-0.912-1.008c-0.086-0.105-0.16-0.219-0.244-0.325c-0.217-0.28-0.435-0.56-0.632-0.855
         c-0.064-0.095-0.116-0.196-0.179-0.293c-0.201-0.316-0.4-0.637-0.579-0.969c-0.037-0.069-0.066-0.143-0.103-0.211
         c-0.188-0.366-0.369-0.736-0.527-1.118c-0.02-0.047-0.033-0.096-0.053-0.143c-0.163-0.405-0.314-0.815-0.442-1.237
         c-0.015-0.049-0.024-0.1-0.038-0.149c-0.123-0.417-0.233-0.838-0.319-1.268c-0.024-0.123-0.036-0.25-0.058-0.375
         c-0.062-0.357-0.125-0.714-0.16-1.079c-0.051-0.496-0.076-0.995-0.076-1.498c0-0.503,0.025-1.002,0.076-1.497
         c0.035-0.365,0.099-0.723,0.16-1.08c0.021-0.125,0.033-0.252,0.058-0.375c0.085-0.426,0.194-0.842,0.315-1.254
         c0.016-0.055,0.025-0.111,0.043-0.166c0.127-0.418,0.277-0.826,0.439-1.229c0.02-0.05,0.035-0.102,0.055-0.15
         c0.157-0.378,0.336-0.744,0.522-1.105c0.038-0.073,0.069-0.15,0.108-0.224c0.176-0.328,0.372-0.643,0.571-0.955
         c0.065-0.102,0.12-0.207,0.187-0.308c0.19-0.283,0.4-0.553,0.609-0.822c0.092-0.118,0.172-0.242,0.268-0.357
         c0.26-0.316,0.539-0.616,0.823-0.91c0.055-0.057,0.102-0.118,0.158-0.174l37.5-37.5c5.858-5.857,15.354-5.856,21.214,0.001
         c5.857,5.858,5.857,15.355-0.001,21.214l-11.893,11.892L240,204h30v-15.954V140h-30h-21.213H145c-8.284,0-15-6.716-15-15V51.213V30
         V0H15C6.716,0,0,6.716,0,15v300c0,8.284,6.716,15,15,15h240c8.284,0,15-6.716,15-15v-40.089V234h-30L181.213,233.999z"
            />
            <polygon
              id="XMLID_227_"
              points="261.213,110 160,8.787 160,51.213 160,110 218.787,110 	"
            />
            <path
              id="XMLID_228_"
              d="M315,204h-2.335H270v30h32.723H315c8.283,0,15-6.717,15-15C330,210.716,323.284,204,315,204z"
            />
          </g>
        </svg>
      );

    case "switchcompany":
      return (
        <svg
          id="bold"
          enableBackground="new 0 0 24 24"
          height="512"
          viewBox="0 0 24 24"
          width="512"
        >
          <path d="m20.25 11c-.414 0-.75-.336-.75-.75v-4.5c0-.689-.561-1.25-1.25-1.25h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c1.517 0 2.75 1.233 2.75 2.75v4.5c0 .414-.336.75-.75.75z" />
          <path d="m20.25 11c-.192 0-.384-.073-.53-.22l-1.75-1.75c-.214-.214-.279-.537-.163-.817s.39-.463.693-.463h3.5c.303 0 .577.183.693.463s.052.603-.163.817l-1.75 1.75c-.146.147-.338.22-.53.22z" />
          <path d="m11.25 21h-5.5c-1.517 0-2.75-1.233-2.75-2.75v-4.5c0-.414.336-.75.75-.75s.75.336.75.75v4.5c0 .689.561 1.25 1.25 1.25h5.5c.414 0 .75.336.75.75s-.336.75-.75.75z" />
          <path d="m5.5 16.25h-3.5c-.303 0-.577-.183-.693-.463s-.052-.603.163-.817l1.75-1.75c.293-.293.768-.293 1.061 0l1.75 1.75c.214.214.279.537.163.817s-.391.463-.694.463z" />
          <circle cx="5" cy="2.5" r="2.5" />
          <path d="m7.25 6h-4.5c-1.517 0-2.75 1.233-2.75 2.75v.5c0 .414.336.75.75.75h8.5c.414 0 .75-.336.75-.75v-.5c0-1.517-1.233-2.75-2.75-2.75z" />
          <path d="m19 19c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5z" />
          <path d="m23.25 24h-8.5c-.414 0-.75-.336-.75-.75v-.5c0-1.517 1.233-2.75 2.75-2.75h4.5c1.517 0 2.75 1.233 2.75 2.75v.5c0 .414-.336.75-.75.75z" />
        </svg>
      );

    case "espp":
      return (
        <svg
          id="Layer_5"
          enableBackground="new 0 0 64 64"
          height="512"
          viewBox="0 0 64 64"
          width="512"
        >
          <g>
            <path d="m23 46h4v15h-4z" />
            <path d="m29 61h4v-21l-4 5.333z" />
            <path d="m35 38h4v23h-4z" />
            <path d="m9 61v-6.481l-5.671 6.481z" />
            <path d="m11 61h4v-13.338l-4 4.571z" />
            <path d="m17 46h4v15h-4z" />
            <path d="m41 38v23h4v-24.586l-1.586 1.586z" />
            <path d="m48 7c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9zm4 7h-2v-1h-3c-.552 0-1 .448-1 1s.448 1 1 1h2c1.654 0 3 1.346 3 3s-1.346 3-3 3v2h-2v-2h-3v-3h2v1h3c.552 0 1-.448 1-1s-.448-1-1-1h-2c-1.654 0-3-1.346-3-3s1.346-3 3-3v-2h2v2h3z" />
            <path d="m47 34.414v26.586h4v-30.302c-.11.022-.224.031-.335.051z" />
            <path d="m48 3c-7.168 0-13 5.832-13 13s5.832 13 13 13 13-5.832 13-13-5.832-13-13-13zm0 24c-6.065 0-11-4.935-11-11s4.935-11 11-11 11 4.935 11 11-4.935 11-11 11z" />
            <path d="m53 61h4v-33.028c-1.206.909-2.551 1.639-4 2.153z" />
            <path d="m7 38h2v-4h2v-12h-2v-4h-2v4h-2v12h2z" />
            <path d="m15 33h2v-4h2v-10h-2v-4h-2v4h-2v10h2z" />
            <path d="m23 26h2v-4h2v-8h-2v-4h-2v4h-2v8h2z" />
            <path d="m44.772 30.642c-.746-.164-1.468-.389-2.169-.66l-2.017 2.018h-8.04l-7 8h-11.984l-12.296 13.321 1.469 1.357 11.702-12.678h12.017l7-8h7.96z" />
          </g>
        </svg>
      );

    case "periods":
      return (
        <svg
          id="Capa_1"
          enableBackground="new 0 0 512 512"
          height="512"
          viewBox="0 0 512 512"
          width="512"
        >
          <g>
            <path d="m15 512h482c8.284 0 15-6.716 15-15v-452c0-8.284-6.716-15-15-15h-46v-15c0-8.284-6.716-15-15-15s-15 6.716-15 15v15h-60v-15c0-8.284-6.716-15-15-15s-15 6.716-15 15v15h-150v-15c0-8.284-6.716-15-15-15s-15 6.716-15 15v15h-60v-15c0-8.284-6.716-15-15-15s-15 6.716-15 15v15h-46c-8.284 0-15 6.716-15 15v452c0 8.284 6.716 15 15 15zm15-30v-330h452v330zm31-422v16c0 8.284 6.716 15 15 15s15-6.716 15-15v-16h60v16c0 8.284 6.716 15 15 15s15-6.716 15-15v-16h150v16c0 8.284 6.716 15 15 15s15-6.716 15-15v-16h60v16c0 8.284 6.716 15 15 15s15-6.716 15-15v-16h31v62h-452v-62z" />
            <path d="m406 212h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z" />
            <path d="m286 242h30c8.284 0 15-6.716 15-15s-6.716-15-15-15h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15z" />
            <path d="m406 302h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z" />
            <path d="m286 332h30c8.284 0 15-6.716 15-15s-6.716-15-15-15h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15z" />
            <path d="m226 302h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z" />
            <path d="m136 302h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z" />
            <path d="m226 392h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z" />
            <path d="m136 392h-30c-8.284 0-15 6.716-15 15s6.716 15 15 15h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z" />
            <path d="m406 362h-120c-8.284 0-15 6.716-15 15v60c0 8.284 6.716 15 15 15h120c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15zm-15 60h-90v-30h90z" />
            <path d="m226 182h-120c-8.284 0-15 6.716-15 15v60c0 8.284 6.716 15 15 15h120c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15zm-15 60h-90v-30h90z" />
          </g>
        </svg>
      );
    case "exception":
      return (
        <svg
          height="448pt"
          viewBox="-19 0 448 448.00024"
          width="448pt"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m94.503906 56h160c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-160c-4.417968 0-8 3.582031-8 8s3.582032 8 8 8zm0 0" />
          <path d="m182.503906 328c0 4.417969-3.582031 8-8 8-4.417968 0-8-3.582031-8-8s3.582032-8 8-8c4.417969 0 8 3.582031 8 8zm0 0" />
          <path d="m181.703125 168.199219c-1.46875-2.566407-4.199219-4.152344-7.160156-4.152344-2.957031 0-5.691407 1.585937-7.160157 4.152344l-94.144531 188.226562c-1.238281 2.476563-1.105469 5.421875.351563 7.777344 1.457031 2.359375 4.03125 3.796875 6.800781 3.796875h188.226563c2.769531 0 5.34375-1.4375 6.800781-3.796875 1.457031-2.355469 1.589843-5.300781.351562-7.777344zm-23.742187 55.289062c4.3125-4.558593 10.308593-7.140625 16.582031-7.140625 6.273437 0 12.273437 2.582032 16.585937 7.140625 4.199219 4.753907 6.15625 11.082031 5.367188 17.375l-5.121094 41c-1.019531 8.09375-7.914062 14.15625-16.070312 14.136719h-1.601563c-8.128906-.015625-14.980469-6.070312-16-14.136719l-5.117187-41c-.800782-6.289062 1.144531-12.617187 5.335937-17.375zm16.542968 128.511719c-13.253906 0-24-10.746094-24-24s10.746094-24 24-24 24 10.746094 24 24-10.746094 24-24 24zm0 0" />
          <path d="m303.785156 0h-258.5625c-4.167968-.015625-7.648437 3.175781-8 7.328125l-37.191406 432c-.199219 2.222656.542969 4.429687 2.046875 6.078125 1.507813 1.648438 3.632813 2.589844 5.867187 2.59375h333.117188c2.238281.003906 4.375-.933594 5.886719-2.582031 1.511719-1.652344 2.257812-3.859375 2.058593-6.089844l-37.191406-432c-.351562-4.167969-3.851562-7.359375-8.03125-7.328125zm-209.28125 24h160c13.253906 0 24 10.746094 24 24s-10.746094 24-24 24h-160c-13.253906 0-24-10.746094-24-24s10.746094-24 24-24zm194.527344 348.617188c-4.347656 7.101562-12.089844 11.414062-20.414062 11.382812h-188.226563c-8.316406 0-16.042969-4.308594-20.414063-11.382812-4.371093-7.078126-4.769531-15.914063-1.046874-23.351563l94.101562-188.226563c4.0625-8.136718 12.378906-13.277343 21.472656-13.277343s17.410156 5.140625 21.472656 13.277343l94.101563 188.226563c3.753906 7.433594 3.355469 16.285156-1.046875 23.351563zm0 0" />
          <path d="m401.785156 400c2.503906.015625 4.875-1.144531 6.398438-3.136719 1.511718-1.933593 2.035156-4.464843 1.410156-6.839843l-72.882812-280.296876 24.992187 290.273438zm0 0" />
          <path d="m175.304688 280c.066406 0 .125-.050781.128906-.121094l5.125-41c.296875-2.351562-.792969-4.667968-2.796875-5.9375-2.003907-1.273437-4.5625-1.273437-6.566407 0-2.003906 1.269532-3.089843 3.585938-2.796874 5.9375l5.128906 41zm0 0" />
        </svg>
      );
    case "periodendreport":
      return (
        <svg
          height="512"
          viewBox="0 0 192 192"
          width="512"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m80 0h32a8 8 0 0 1 8 8v24a0 0 0 0 1 0 0h-48a0 0 0 0 1 0 0v-24a8 8 0 0 1 8-8z" />
          <path d="m160 16h-32v16a8 8 0 0 1 -8 8h-48a8 8 0 0 1 -8-8v-16h-32a8 8 0 0 0 -8 8v160a8 8 0 0 0 8 8h128a8 8 0 0 0 8-8v-160a8 8 0 0 0 -8-8zm-60 40.259a31.988 31.988 0 0 1 27.384 37.986l-27.384-9.128zm-8 0v31.741a4 4 0 0 0 2.735 3.8l30.117 10.039a32 32 0 1 1 -32.852-45.58zm52 119.741h-96v-8h16v-16h16v16h8v-24h16v24h8v-32h16v32h16z" />
        </svg>
      );
  }
}
